var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`input-row ${_vm.fullWidth ? 'full-width' : ''} ${_vm.expandChildren ? 'expand-children' : ''}`},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }